import { render, staticRenderFns } from "./AppSliderEditor.vue?vue&type=template&id=47ecb93d&"
import script from "./AppSliderEditor.vue?vue&type=script&lang=js&"
export * from "./AppSliderEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports